import { Component, OnInit } from '@angular/core';
import { DataTablesModule } from 'angular-datatables';

interface Checklist {
  id: number;
  nomeFormulario: string;
  status: 'A Fazer' | 'Em Processo' | 'Finalizado';
  dataInicio: Date;
  dataFim: Date;
}

@Component({
  selector: 'app-checklist-cliente',
  templateUrl: './checklist-cliente.component.html',
  styleUrls: ['./checklist-cliente.component.scss']
})
export class ChecklistClienteComponent implements OnInit {
  checklists: Checklist[] = [];
  dtOptions: DataTables.Settings = {};

  constructor() {}

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      processing: true,
      language: {
        url: '//cdn.datatables.net/plug-ins/1.13.7/i18n/pt-BR.json'
      }
    };
    this.carregarChecklists();
  }

  carregarChecklists() {
    // Mock data - substituir por chamada à API
    this.checklists = [
      {
        id: 1,
        nomeFormulario: 'Checklist de Segurança',
        status: 'A Fazer',
        dataInicio: new Date('2024-03-15'),
        dataFim: new Date('2024-03-20')
      },
      {
        id: 2,
        nomeFormulario: 'Checklist de Qualidade',
        status: 'Em Processo',
        dataInicio: new Date('2024-03-16'),
        dataFim: new Date('2024-03-21')
      },
      {
        id: 3,
        nomeFormulario: 'Checklist de Manutenção',
        status: 'Finalizado',
        dataInicio: new Date('2024-03-17'),
        dataFim: new Date('2024-03-22')
      }
    ];
  }

  responderChecklist(checklist: Checklist) {
    // Implementar navegação para a tela de resposta do checklist
    console.log('Responder checklist:', checklist);
  }

  getStatusClass(status: string): string {
    switch (status) {
      case 'A Fazer':
        return 'badge-warning';
      case 'Em Processo':
        return 'badge-info';
      case 'Finalizado':
        return 'badge-success';
      default:
        return 'badge-secondary';
    }
  }

  podeResponder(status: string): boolean {
    return status !== 'Finalizado';
  }
} 